<app-nav-bar></app-nav-bar>

<!-- Admin Page Container with Sidebar Layout -->
<div class="admin-page-container">
  <!-- Left Sidebar Navigation -->
  <aside class="admin-sidebar" role="complementary">
    <div class="admin-sidebar-header">
      <h1 class="admin-page-title">
        <fa-icon icon="cog" class="title-icon"></fa-icon>
        Administration
      </h1>
      <p class="admin-page-subtitle">Manage board settings</p>
    </div>

    <nav class="admin-nav" role="navigation" aria-label="Admin sections">
      <ul class="admin-nav-list">
        <li class="admin-nav-item">
          <button 
            [attr.aria-selected]="usersSelected"
            [ngClass]="{
              'admin-nav-link': true,
              'admin-nav-link-active': usersSelected,
              'admin-nav-link-inactive': !usersSelected
            }" 
            [routerLink]="[ 'users' ]"
            routerLinkActive="admin-nav-link-active"
            (click)="setActiveTab('users')"
            type="button">
            <fa-icon icon="users" class="nav-icon"></fa-icon>
            <span class="nav-label">Users</span>
            <span class="nav-indicator"></span>
          </button>
        </li>

        <li class="admin-nav-item">
          <button 
            [attr.aria-selected]="styleSelected"
            [ngClass]="{
              'admin-nav-link': true,
              'admin-nav-link-active': styleSelected,
              'admin-nav-link-inactive': !styleSelected
            }" 
            [routerLink]="[ 'style' ]"
            routerLinkActive="admin-nav-link-active"
            (click)="setActiveTab('style')"
            type="button">
            <fa-icon icon="palette" class="nav-icon"></fa-icon>
            <span class="nav-label">Style</span>
            <span class="nav-indicator"></span>
          </button>
        </li>

        <li class="admin-nav-item">
          <button 
            [attr.aria-selected]="logoSelected"
            [ngClass]="{
              'admin-nav-link': true,
              'admin-nav-link-active': logoSelected,
              'admin-nav-link-inactive': !logoSelected
            }" 
            [routerLink]="[ 'logo' ]"
            routerLinkActive="admin-nav-link-active"
            (click)="setActiveTab('logo')"
            type="button">
            <fa-icon icon="image" class="nav-icon"></fa-icon>
            <span class="nav-label">Logo</span>
            <span class="nav-indicator"></span>
          </button>
        </li>

        <li class="admin-nav-item">
          <button 
            [attr.aria-selected]="configSelected"
            [ngClass]="{
              'admin-nav-link': true,
              'admin-nav-link-active': configSelected,
              'admin-nav-link-inactive': !configSelected
            }" 
            [routerLink]="[ 'config' ]"
            routerLinkActive="admin-nav-link-active"
            (click)="setActiveTab('config')"
            type="button">
            <fa-icon icon="sliders-h" class="nav-icon"></fa-icon>
            <span class="nav-label">Config</span>
            <span class="nav-indicator"></span>
          </button>
        </li>
      </ul>
    </nav>
  </aside>

  <!-- Main Content Area -->
  <main class="admin-main-content" role="main">
    <router-outlet (activate)='onActivate($event)'></router-outlet>
  </main>
</div>